import { useCallback, useContext, useState } from 'react'

import { MobXProviderContext } from 'mobx-react'

import { IMeCompanyQuickFiltersProps } from '~/client/src/shared/components/Filters/MeCompanyQuickFilters/MeCompanyQuickFilters'
import UserProject from '~/client/src/shared/models/UserProject'

interface IRowIdentity {
  id: string
  companyId: string
}

interface IMeCompanyFilter {
  apply: <T extends IRowIdentity>(rows: T[]) => T[]
  props: IMeCompanyQuickFiltersProps
}

export function useMeCompanyFilter(): IMeCompanyFilter {
  const stores = useContext(MobXProviderContext) as any
  const currentUserId: string | undefined = stores.state?.user?.id
  const currentUserCompanyId = UserProject.getCompanyId(
    stores.state?.user,
    stores.userProjectsStore,
  )

  const [isOnlyMe, setIsOnlyMe] = useState(false)
  const [isOnlyMyCompany, setIsOnlyMyCompany] = useState(false)

  const onToggleMe = useCallback(() => setIsOnlyMe(prev => !prev), [])
  const onToggleMyCompany = useCallback(
    () => setIsOnlyMyCompany(prev => !prev),
    [],
  )

  const apply = useCallback(
    <T extends IRowIdentity>(rows: T[]): T[] => {
      let filtered = rows
      if (isOnlyMe && currentUserId) {
        filtered = filtered.filter(row => row.id === currentUserId)
      }
      if (isOnlyMyCompany && currentUserCompanyId) {
        filtered = filtered.filter(
          row => row.companyId === currentUserCompanyId,
        )
      }
      return filtered
    },
    [isOnlyMe, isOnlyMyCompany, currentUserId, currentUserCompanyId],
  )

  return {
    apply,
    props: {
      isOnlyMe,
      isOnlyMyCompany,
      onToggleMe,
      onToggleMyCompany,
      isMeDisabled: !currentUserId,
      isMyCompanyDisabled: !currentUserCompanyId,
    },
  }
}
